/* © Facilogi. See COPYRIGHT file for full copyright & licensing details. */

import Configuration from "./Configuration";
import Coupons from "./Coupons";
import Customers from "./Customers";
import Products from "./Products";
import Plans from "./Plans";
import Prices from "./Prices";
import PriceTargets from "./PriceTargets";
import Subscriptions from "./Subscriptions";
import Payments from "./Payments";
import AdsPublication from "./AdsPublication";
import Roles from "./Roles";
import ConsoleUsers from "./ConsoleUsers";
import Activate from "./Activate";
import ForgotPassword from "./ForgotPassword";
import ResetPassword from "./ResetPassword";
import Home from "./Home";
import AgentKb from "./AgentKb";
import ApiKeys from "./ApiKeys";
import Newsletters from "./Newsletters";
import DesignCategories from "./DesignCategories";

export default {
    GLOBAL_appBrand: process.env.APP_BRAND || "",

    GLOBAL_defaultDateFormat: "D MMM YYYY",
    GLOBAL_defaultDateTimeFormat: "D MMM YYYY à HH:mm",
    GLOBAL_decimalSeparator: ",",
    GLOBAL_decimalThousandSeparator: " ",
    GLOBAL_unlimited: "{} illimité(e)s",
    GLOBAL_default_standard_date_format: "DD/MM/YYYY",
    GLOBAL_defaultStandardDateTimeFormat: "DD/MM/YY HH:mm",

    GLOBAL_sessionExpired: "Votre session est expirée. Veuillez vous reconnecter.",
    GLOBAL_invalidSession: "Session invalide. Veuillez vous reconnecter.",

    SIGNIN_login: "S'identifier",
    SIGNIN_password: "Mot de passe",
    SIGNIN_logIn: "S'identifier",
    SIGNIN_forgotPassword: "Mot de passe oublié?",
    SIGNIN_showPassword: "Afficher le mot de passe",
    SIGNIN_hidePassword: "Cacher le mot de passe",
    SIGNIN_email: "Email",
    SIGNIN_invalidCredentials: "Email ou mot de passe incorrect.",
    SIGNIN_continue: "Continuer",
    SIGNIN_back: "Retour",

    SIGNIN_2faSetupTitle: "Configurer la double authentification",
    SIGNIN_2faSetupIntro: "Pour sécuriser votre accès, configurez une application "
        + "d'authentification (Google Authenticator, Authy, 1Password…).",
    SIGNIN_2faStepApp: "Installez une application d'authentification sur votre téléphone.",
    SIGNIN_2faStepKey: "Ajoutez un compte et saisissez la clé ci-dessous.",
    SIGNIN_2faManualKey: "Clé de configuration",
    SIGNIN_2faCodeLabel: "Code à 6 chiffres",
    SIGNIN_2faCodePlaceholder: "123456",
    SIGNIN_2faActivate: "Activer",
    SIGNIN_2faVerifyTitle: "Vérification en deux étapes",
    SIGNIN_2faVerifyIntro: "Saisissez le code affiché dans votre application "
        + "d'authentification.",
    SIGNIN_2faRecoveryHint: "Vous pouvez aussi utiliser un code de secours.",
    SIGNIN_totpEnterFreshCode: "Le code a expiré. Saisissez le code actuel de votre application.",

    SIGNIN_recoveryTitle: "Codes de secours",
    SIGNIN_recoveryIntro: "Conservez ces codes en lieu sûr. Chacun ne fonctionne qu'une fois et "
        + "permet de vous connecter si vous perdez votre téléphone.",
    SIGNIN_recoveryCopy: "Copier les codes",
    SIGNIN_recoveryAck: "J'ai noté mes codes de secours.",
    SIGNIN_recoveryContinue: "Continuer",

    USERS_accountDisabled: "Ce compte est désactivé.",
    USERS_totpEnrollmentRequired: "Configuration de la double authentification requise.",
    USERS_totpCodeRequired: "Saisissez votre code de vérification.",
    USERS_totpCodeInvalid: "Code de vérification incorrect.",
    USERS_totpAlreadyEnrolled: "La double authentification est déjà configurée.",
    USERS_passwordTooShort: "Le mot de passe est trop court.",
    USERS_currentPasswordInvalid: "Le mot de passe actuel est incorrect.",
    USERS_invalidResetToken: "Ce lien de réinitialisation est invalide ou a expiré.",
    USERS_emailRequired: "L'adresse email est requise.",
    GLOBAL_invalidUsernamePasswordCombination: "Email ou mot de passe incorrect.",
    GLOBAL_save: "Enregistrer",

    PROFILE_title: "Votre profil",
    PROFILE_groupGeneral: "Général",
    PROFILE_navProfile: "Profil",
    PROFILE_navPreferences: "Préférences",
    PROFILE_navAuthentication: "Authentification",
    PROFILE_saved: "Vos modifications ont été enregistrées.",
    PROFILE_passwordSection: "Mot de passe",
    PROFILE_changePassword: "Changer le mot de passe",
    PROFILE_currentPassword: "Mot de passe actuel",
    PROFILE_newPassword: "Nouveau mot de passe",
    PROFILE_confirmPassword: "Confirmer le mot de passe",
    PROFILE_showPassword: "Afficher les mots de passe",
    PROFILE_savePassword: "Mettre à jour le mot de passe",
    PROFILE_passwordChanged: "Votre mot de passe a été modifié.",
    PROFILE_passwordMismatch: "Les mots de passe ne correspondent pas.",

    PREFERENCES_timezone: "Fuseau horaire",
    PREFERENCES_timeFormat: "Format de l'heure",
    PREFERENCES_timeFormat12: "12 heures (ex. 2:13 pm)",
    PREFERENCES_timeFormat24: "24 heures (ex. 14:13)",

    AUTH_intro: "Renforcez la sécurité de votre compte en exigeant une étape "
        + "supplémentaire à la connexion.",
    AUTH_2faTitle: "Double authentification",
    AUTH_2faSub: "Utilisez un code généré par une application d'authentification.",
    AUTH_2faOn: "Activée",
    AUTH_2faOff: "Désactivée",
    AUTH_2faEnable: "Activer la double authentification",
    AUTH_2faDisable: "Désactiver",
    AUTH_2faDisableConfirm: "Désactiver la double authentification pour votre compte ?",
    AUTH_2faEnabled: "Double authentification activée.",
    AUTH_2faDisabled: "Double authentification désactivée.",
    AUTH_2faStepApp: "1. Installez une application d'authentification sur votre téléphone "
        + "(Google Authenticator, Authy...).",
    AUTH_2faStepKey: "2. Ajoutez un compte et saisissez la clé ci-dessous.",
    AUTH_2faCodeLabel: "Code à 6 chiffres",
    AUTH_2faCodePlaceholder: "123456",
    AUTH_2faActivate: "Activer",
    AUTH_recoveryIntro: "Conservez ces codes de secours en lieu sûr. Chacun ne fonctionne "
        + "qu'une fois et permet de vous connecter si vous perdez votre téléphone.",
    AUTH_recoveryCopy: "Copier les codes",
    AUTH_recoveryCopied: "Codes de secours copiés.",
    AUTH_recoveryDone: "J'ai noté mes codes",
    AUTH_recoveryRegenerate: "Régénérer les codes de secours",
    AUTH_sessionsTitle: "Sessions actives",
    AUTH_sessionsSub: "Ces appareils sont actuellement connectés à votre compte. "
        + "Déconnectez ceux que vous ne reconnaissez pas.",
    AUTH_sessionsCurrent: "Appareil actuel",
    AUTH_sessionsSignOut: "Déconnecter",
    AUTH_sessionsSignOutConfirm: "Déconnecter cet appareil ? Sa session sera révoquée.",
    AUTH_sessionsSignedOut: "Appareil déconnecté",

    GLOBAL_configuration: "Configuration",
    GLOBAL_products: "Produits",
    GLOBAL_PRICE_TARGETS: "Type de prix",
    MAIN_MENU_dashboard: "Tableau de bord",
    MAIN_MENU_products: "Produits",
    MAIN_MENU_plans: "Plans",
    MAIN_MENU_coupons: "Bons de réduction",
    MAIN_MENU_yearlyCoupon: "Coupon annuel",
    MAIN_MENU_priceTargets: "Type de prix",
    MAIN_MENU_customers: "Clients",
    MAIN_MENU_users: "Utilisateurs",
    MAIN_MENU_consoleTeam: "Utilisateurs Console",
    MAIN_MENU_consoleRoles: "Rôles de privilèges",
    MAIN_MENU_configuration: "Configuration",
    MAIN_MENU_settings: "Paramètres",
    MAIN_MENU_subscriptionPlans: "Plans d'abonnements",
    MAIN_MENU_subscriptions: "Abonnements",
    MAIN_MENU_invoicing: "Paiements",
    MAIN_MENU_agentKb: "Support clients",
    MAIN_MENU_api: "API",
    MAIN_MENU_newsletters: "Newsletter automatique",
    MAIN_MENU_apiKeys: "Clés API",
    MAIN_MENU_designCategories: "Catégories de modèles",
    MAIN_MENU_agentKbGeneral: "Vue générale",
    MAIN_MENU_agentKbUsers: "Par utilisateur",
    MAIN_MENU_agentKbConversations: "Conversations",
    MAIN_MENU_agentKbUsage: "Usage",
    MAIN_MENU_adsPublication: "Portails d’annonces",
    MAIN_MENU_adsPublicationGeneral: "Configuration générale",
    MAIN_MENU_adsPublicationSalePoint: "Clients et portails",
    MAIN_MENU_myAccount: "Mon compte",
    MAIN_MENU_signOut: "Se déconnecter",
    MAIN_MENU_whatsNew: "Nouveautés",
    MAIN_MENU_yourProfile: "Votre profil",
    MAIN_MENU_resources: "Ressources et guides",

    GLOBAL_help: "Aide",
    GLOBAL_collapse: "Réduire le menu",
    GLOBAL_expand: "Déployer le menu",
    GLOBAL_darkMode: "Mode sombre",
    GLOBAL_lightMode: "Mode clair",
    GLOBAL_warning: "Avertissement",
    GLOBAL_fillRequiredField: "Ce champs est requis",
    GLOBAL_cancel: "Annuler",
    GLOBAL_internalError: "Erreur interne du serveur",

    GLOBAL_tableActionSelected: "sélectionné(e)",
    GLOBAL_tableActionMultiSelected: "sélectionné(e)s",

    GLOBAL_currency: "€",
    GLOBAL_excludingTaxSuffix: "HT",
    GLOBAL_includingTaxSuffix: "TTC",
    GLOBAL_percentage: "%",
    GLOBAL_total: "Total",
    GLOBAL_unknown: "Inconnu",
    GLOBAL_actionDone: "J'ai terminé",

    GLOBAL_confirm: "Confirmer",
    GLOBAL_yes: "Oui",
    GLOBAL_no: "Non",
    GLOBAL_formSave: "Enregistrer",
    GLOBAL_next: "Suivant",
    GLOBAL_actions: "Actions",

    GLOBAL_Product: "Produit",
    GLOBAL_CUSTOMER: "Client",
    GLOBAL_COUPON: "Bons de réduction",
    GLOBAL_Price: "Prix",

    GLOBAL_attention: "Attention",
    GLOBAL_actionArchive: "Archiver",
    GLOBAL_actionDelete: "Supprimer",
    GLOBAL_actionUpdate: "Modifier",

    GLOBAL_statusActive: "Actif",
    GLOBAL_statusArchived: "Archivé",

    GLOBAL_Language: "Langue",
    GLOBAL_authenticationProblem: "L'utilisateur n'est pas authentifié",

    GLOBAL_filterName: "Nom",
    GLOBAL_filterNamePlaceholder: "Filtrer par nom",
    GLOBAL_filterStatus: "État",
    GLOBAL_filterStatusPlaceholder: "État",

    GLOBAL_value: "Valeur",
    GLOBAL_confirmAction: "Oui, je confirme",

    FILTER_or: " <b>ou</b> ",
    FILTER_and: "<b>et</b>",
    FILTER_add: "Ajouter un filtre",
    FILTER_apply: "Appliquer",
    FILTER_contains: "Contient",
    FILTER_value: "Valeur",
    FILTER_filterBy: "Filtrer par {0}",
    FILTER_and_x_more: " et {0} autres",
    FILTER_propertyTagsId: "tag",
    FILTER_propertyTypeId: "type",
    FILTER_propertySubTypeId: "sous-type",

    GLOBAL_noResults: "Aucun résultat",
    GLOBAL_search: "Search",

    GLOBAL_fieldSequence: "Séquence",

    GLOBAL_configurationCoupons: "Bons de réduction",

    CONFIGURATION_navigationGeneral: "Général",
    CONFIGURATION__yearlyCoupon: "Bon de réduction annuelle",

    TRANSLATIONS_en: "Anglais",
    TRANSLATIONS_fr: "Français",
    TRANSLATIONS_es: "Espagnole",
    TRANSLATIONS_translated: "Traduit",
    TRANSLATIONS_notTranslated: "Non traduit",
    TRANSLATIONS_title: "Traduction de la valeur",
    TRANSLATIONS_notificationTitle: "Traduction",
    TRANSLATIONS_updateTitle: "Modifier une traduction",
    TRANSLATIONS_updated: "Traduction mise à jour avec succés",


    ...Configuration,
    ...Coupons,
    ...Customers,
    ...Products,
    ...Plans,
    ...Prices,
    ...PriceTargets,
    ...Subscriptions,
    ...Payments,
    ...AdsPublication,
    ...Roles,
    ...ConsoleUsers,
    ...Activate,
    ...ForgotPassword,
    ...ResetPassword,
    ...Home,
    ...AgentKb,
    ...ApiKeys,
    ...Newsletters,
    ...DesignCategories
};
